import React from "react";
/* Import Boostrap */
import { Row } from 'react-bootstrap';

import FooterDescription from "./footer-description";
import FooterCopyright from "./footer-copyright";
import SectionContainer from '../containers/section-container';

export default class Footer extends React.Component {
    render() {
        return (
            <footer id="gtco-footer">
                <div id="gtco-subscribe">
                    <SectionContainer>
                        <FooterDescription footerContent={this.props.footerContent} />
                        <Row>
                            <FooterCopyright footerCopyright={this.props.footerCopyright} footerPrivacyPolicy={this.props.footerPrivacyPolicy} />
                        </Row>
                    </SectionContainer>
                </div>
            </footer>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/footer/footer.js